import { BaseAPI } from 'API/BaseApi';
import { IGiactRequest } from '../../../types/order/escrow/request/IGiactRequest';
import { eAPITags } from '../../eAPITags';

const GiactAPI = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    updateGiact: build.mutation<void, IGiactRequest>({
      query: ({ disbursementId, disbursementType, ...rest }) => ({
        url: `/timber/api/internal/v1/giact/${disbursementType}/${disbursementId}/verify`,
        method: 'POST',
        body: rest,
      }),
      invalidatesTags: (result, error, { disbursementId, disbursementType }) => [
        disbursementType === 'wire'
          ? { type: eAPITags.WireDisbursement, id: disbursementId }
          : { type: eAPITags.ACHDisbursement, id: disbursementId },
      ],
    }),
  }),
});

export const { useUpdateGiactMutation } = GiactAPI;
